export enum ProductType {
  EV_OPTIMIZER = "+EV Optimizer",
  WHALE_WATCH = "Whale Watch",
  EV_SNIPER = "+EV Sniper",
}
